import BigNumber from '@exchange/helpers/bignumber';

/*
export const getMinAmountForMarketOrder = ({ lastPrice, minSize }: { lastPrice: number; minSize: number }) => {
  if (Number.isNaN(lastPrice)) {
    return new BigNumber(0);
  }

  return new BigNumber(minSize).div(lastPrice);
};
*/

export const getMinAmount = ({ amountPrecision }: { amountPrecision: number }) => new BigNumber(10).pow(-amountPrecision);

export const getMinPrice = ({ marketPrecision }: { marketPrecision: number }) => new BigNumber(10).pow(-marketPrecision);
